import { useEffect } from "react";
import MainPanel from "../components/main-panel/main-panel";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectCurrentUser } from "src/modules/users/selector";
import NoAccess from "../components/no-access/no-access";
import { checkAuth } from "../utils/auth";
import { mode } from "src/constants";
import { siteUrl } from "src/api/config";
import { fetchSettingsRequest } from "../store/settings/settings";

export default function Gop() {
  const user = useAppSelector((state) => selectCurrentUser(state));
  const dispatch = useAppDispatch();

  const isNoAccess =
    !user.infoVPO.user &&
    !user.infoVPO.admin &&
    !user.infoVPO.zone &&
    !user.infoVPO.adminRegion;

  useEffect(() => {
    checkAuth().then((result) => {
      if (!result)
        window.location.href =
          "https://supply.napitkivmeste.ru/splogin?backUrl=" +
          siteUrl +
          "/dashboard/2";
    });
    dispatch(fetchSettingsRequest());
  }, []);

  if (isNoAccess && user.displayName) return <NoAccess />;

  return <MainPanel />;
}
